module.exports = __webpack_public_path__ + "img/sand-dune-decal-08.565c4b7c.png";